import { FC } from 'react'
import './styles.css'
import { Trans } from 'react-i18next'
import { WizardStep } from './WizardConfigurationUtil'
import { FormLabel } from '../../components/Form/FormLabel'
import { useFetchLocation } from '../../hooks/useFetchLocation'
import { GeoLocation, Vehicle } from '../../types/api.types'

interface WizardOverviewComponentProps {
  provider: string
  vehicle: Vehicle
  location: GeoLocation
  onEdit: (step: WizardStep) => void
}

const WizardOverviewComponent: FC<WizardOverviewComponentProps> = ({ provider, vehicle, location, onEdit }) => {
  const { address } = useFetchLocation(location)

  return (
    <>
      <p className="wizard-header">
        <Trans i18nKey="wizard.overview.description" />
      </p>
      <div>
        <FormLabel titleKey={'wizard.overview.provider'} value={provider} />

        <FormLabel
          titleKey={'wizard.overview.vehicle'}
          value={vehicle.model}
          trailingAccessory={<EditStepButton onEdit={() => onEdit('VEHICLE')} />}
        />
        <FormLabel titleKey={'wizard.overview.vin'} value={vehicle.vin} />

        <FormLabel
          titleKey={'wizard.overview.location'}
          value={address}
          trailingAccessory={<EditStepButton onEdit={() => onEdit('LOCATION')} />}
        />
      </div>

      <div className="wizard-overview-disclaimer">
        <Trans i18nKey={'wizard.overview.acknowledgement'}>{{ provider }}</Trans>
      </div>
    </>
  )
}

const EditStepButton: FC<{ onEdit: () => void }> = ({ onEdit }) => {
  return (
    <div>
      <button className="wizard-overview-edit-step" onClick={() => onEdit()}>
        <Trans i18nKey={'wizard.overview.editStep'} />
      </button>
    </div>
  )
}

export default WizardOverviewComponent
